"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObserverList = void 0;
class ObserverList {
    constructor() {
        this.observers = [];
        this.notify = (msg) => {
            this.observers.forEach((obs) => {
                obs(msg);
            });
        };
        this.add = (obs) => {
            this.observers.push(obs);
        };
        this.remove = (obs) => {
            const index = this.observers.indexOf(obs);
            if (index >= 0) {
                this.observers.splice(index, 1);
            }
        };
    }
}
exports.ObserverList = ObserverList;
